export const GET_TICKET_LIST = "GET_TICKET_LIST"
export const CHOICE_CHAIR = "CHOICE_CHAIR"
export const BOOKING_CHAIR = "BOOKING_CHAIR"
export const GET_CODE_PHIM_BOOKING = "GET_CODE_PHIM_BOOKING";
